let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("bjmre"), load("bcQs2"), load("11DLa"), load("aNQmP")]).then(() => parcelRequire('h0KE6'));